export enum LocalStorageKeys {
  SPLASH_SCREEN = 'splash-screen',
}

export const useLocalStorage = <T>(msid: string, keyName: LocalStorageKeys, defaultValue: T) => {
  const key = `${keyName}-${msid}`;

  const setItem = (value: T) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log('error setting item from localStorage', { error });
    }
  };

  const getItem = (): T => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : defaultValue;
    } catch (error) {
      console.log('error getting item from localStorage', { error });
      return defaultValue;
    }
  };

  const removeItem = () => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.log('error removing item from localStorage', { error });
    }
  };

  return { setItem, getItem, removeItem };
};
